export enum TasksTabs {
  OPEN = "OPEN",
  IN_PROGRESS = "IN_PROGRESS",
  UPCOMING = "UPCOMING",
  COMPLETED = "COMPLETED",
  CLOSED = "CLOSED",
}

export const MULTI_SELECT_TASK_TABS = [
  TasksTabs.OPEN,
  TasksTabs.IN_PROGRESS,
  TasksTabs.COMPLETED,
  TasksTabs.CLOSED,
];
